import { z } from 'zod';
import { HttpErrorResponse } from './validation-error';
const Email = z.string().min(1);
export const verifyUserRoute = {
    version: 1,
    method: 'GET',
    path: '/verify-user',
    name: 'verify-user',
    request: {},
    responses: {
        200: z.union([
            z.object({ isAppUserOnly: z.literal(true) }),
            z
                .object({ isAppUserOnly: z.literal(false), isSignUp: z.boolean() })
                .passthrough(),
        ]),
        401: HttpErrorResponse,
    },
};
export const passwordlessStartRoute = {
    version: 1,
    method: 'POST',
    path: '/auth/passwordless/start',
    name: 'passwordless-start',
    request: {
        body: z.object({ email: Email, turnstileToken: z.string().min(1) }),
    },
    responses: {
        200: z.object({ sent: z.literal(true) }),
        400: HttpErrorResponse,
        403: HttpErrorResponse,
        502: HttpErrorResponse,
    },
};
export const passwordlessVerifyRoute = {
    version: 1,
    method: 'POST',
    path: '/auth/passwordless/verify',
    name: 'passwordless-verify',
    request: {
        body: z.object({ email: Email, code: z.string().regex(/^[0-9]{4,12}$/) }),
    },
    responses: {
        200: z.object({
            accessToken: z.string(),
            idToken: z.string(),
            expiresIn: z.number(),
            tokenType: z.string(),
        }),
        400: HttpErrorResponse,
        401: HttpErrorResponse,
        429: HttpErrorResponse,
        502: HttpErrorResponse,
    },
};
